import {Model} from './Model';

interface FairEventInfo {
  id: string;
  title: string;
  year: number;
}

export class LeadTrackingPermission extends Model {
  public contact: number;
  public fairEvent: FairEventInfo;
  public active: boolean;
  public createdAt: Date;
  public updatedAt: Date;

  constructor(data: any) {
    super(data);

    this.contact = data.contact;
    this.fairEvent = data.fairEvent;
    this.active = data.active;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }

  toString(): string {
    return `${this.fairEvent.title} ${this.fairEvent.year}`;
  }
}
